/**
 * Ícones do cockpit (2026-10-09, pedido do Bruno: "melhora os ícones de tudo").
 *
 * Um conjunto só, de traço fino (família Lucide, grade 24×24), no lugar dos
 * emojis coloridos. Mesmo desenho do menu lateral (LayoutSistema → Ic), mas
 * independente da casca: o traço vem por atributo, então funciona em qualquer
 * tela e nos dois temas (a cor é `currentColor`, herda do texto).
 *
 * Uso: <Icone nome="telefone" />  ·  <Icone nome="lixo" tamanho={18} />
 * Nome desconhecido desenha um círculo (nunca quebra a tela).
 */
import React from 'react';

const h = React.createElement;

/* Cada ícone é uma lista de [tag, atributos] (traço Lucide, grade 24×24).
   Em JS puro, sem JSX: os testes de tela carregam este arquivo direto no Node. */
const D = {"telefone":[["path",{"d":"M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"}]],
  "telefone-desligar":[["path",{"transform":"rotate(135 12 12)","d":"M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"}]],
  "video":[["path",{"d":"m16 13 5.22 3.48a.5.5 0 0 0 .78-.42V7.89a.5.5 0 0 0-.75-.43L16 10.5"}],["rect",{"x":"2","y":"6","width":"14","height":"12","rx":"2"}]],
  "video-off":[["path",{"d":"M10.66 6H14a2 2 0 0 1 2 2v2.5l5.25-3.03a.5.5 0 0 1 .75.43v8.2"}],["path",{"d":"M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2"}],["path",{"d":"m2 2 20 20"}]],
  "microfone":[["rect",{"x":"9","y":"2","width":"6","height":"12","rx":"3"}],["path",{"d":"M19 10v1a7 7 0 0 1-14 0v-1"}],["path",{"d":"M12 18v4"}]],
  "microfone-off":[["path",{"d":"M15 9.34V5a3 3 0 0 0-5.68-1.33"}],["path",{"d":"M9 9v2a3 3 0 0 0 5.12 2.12"}],["path",{"d":"M16.95 16.95A7 7 0 0 1 5 11v-1"}],["path",{"d":"M19 10v1a7 7 0 0 1-.11 1.23"}],["path",{"d":"M12 18v4"}],["path",{"d":"m2 2 20 20"}]],
  "tela":[["rect",{"x":"2","y":"3","width":"20","height":"14","rx":"2"}],["path",{"d":"M8 21h8M12 17v4"}]],
  "compartilhar-tela":[["path",{"d":"M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"}],["path",{"d":"M8 21h8M12 17v4"}],["path",{"d":"m17 8 5-5M17 3h5v5"}]],
  "mensagem":[["path",{"d":"M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"}]],
  "mensagens":[["path",{"d":"M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z"}],["path",{"d":"M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1"}]],
  "whatsapp":[["path",{"d":"M7.9 20A9 9 0 1 0 4 16.1L2 22Z"}],["path",{"d":"M9.5 9.5c.3 2 1.9 3.8 4 4.4l.9-.9 1.6.7-.4 1.3c-3.3-.1-6-2.8-6.1-6.1l1.3-.4.7 1.6z"}]],
  "enviar":[["path",{"d":"m22 2-7 20-4-9-9-4Z"}],["path",{"d":"M22 2 11 13"}]],
  "clipe":[["path",{"d":"m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"}]],
  "sorriso":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"M8 14s1.5 2 4 2 4-2 4-2"}],["path",{"d":"M9 9h.01M15 9h.01"}]],
  "sino":[["path",{"d":"M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"}],["path",{"d":"M10.3 21a1.94 1.94 0 0 0 3.4 0"}]],
  "sino-off":[["path",{"d":"M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5"}],["path",{"d":"M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7"}],["path",{"d":"M10.3 21a1.94 1.94 0 0 0 3.4 0"}],["path",{"d":"m2 2 20 20"}]],
  "mao":[["path",{"d":"M18 11V6a2 2 0 0 0-4 0v5"}],["path",{"d":"M14 10V4a2 2 0 0 0-4 0v6"}],["path",{"d":"M10 10.5V6a2 2 0 0 0-4 0v8"}],["path",{"d":"M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"}]],
  "responder":[["path",{"d":"m9 17-5-5 5-5"}],["path",{"d":"M20 18v-2a4 4 0 0 0-4-4H4"}]],
  "copiar":[["rect",{"x":"8","y":"8","width":"14","height":"14","rx":"2"}],["path",{"d":"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"}]],
  "fixar":[["path",{"d":"M12 17v5"}],["path",{"d":"M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"}]],
  "arrastar":[["circle",{"cx":"9","cy":"5","r":"1"}],["circle",{"cx":"9","cy":"12","r":"1"}],["circle",{"cx":"9","cy":"19","r":"1"}],["circle",{"cx":"15","cy":"5","r":"1"}],["circle",{"cx":"15","cy":"12","r":"1"}],["circle",{"cx":"15","cy":"19","r":"1"}]],
  "maximizar":[["path",{"d":"M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"}]],
  "minimizar":[["path",{"d":"M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"}]],
  "tela-cheia":[["path",{"d":"M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"}]],
  "grade":[["rect",{"x":"3","y":"3","width":"7","height":"7","rx":"1"}],["rect",{"x":"14","y":"3","width":"7","height":"7","rx":"1"}],["rect",{"x":"14","y":"14","width":"7","height":"7","rx":"1"}],["rect",{"x":"3","y":"14","width":"7","height":"7","rx":"1"}]],
  "destaque":[["rect",{"x":"3","y":"3","width":"18","height":"12","rx":"2"}],["rect",{"x":"3","y":"18","width":"5","height":"3","rx":"1"}],["rect",{"x":"10","y":"18","width":"5","height":"3","rx":"1"}],["rect",{"x":"17","y":"18","width":"4","height":"3","rx":"1"}]],
  "imagem-flutuante":[["path",{"d":"M2 10V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5"}],["path",{"d":"M2 14v5a2 2 0 0 0 2 2h4"}],["rect",{"x":"12","y":"13","width":"10","height":"8","rx":"2"}]],
  "usuario":[["circle",{"cx":"12","cy":"8","r":"4"}],["path",{"d":"M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1"}]],
  "usuarios":[["path",{"d":"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"}],["circle",{"cx":"9","cy":"7","r":"4"}],["path",{"d":"M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"}]],
  "usuario-mais":[["path",{"d":"M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"}],["circle",{"cx":"9","cy":"7","r":"4"}],["path",{"d":"M19 8v6M22 11h-6"}]],
  "predio":[["rect",{"x":"4","y":"2","width":"16","height":"20","rx":"2"}],["path",{"d":"M9 22v-4h6v4"}],["path",{"d":"M8 6h.01M16 6h.01M12 6h.01M12 10h.01M12 14h.01M16 10h.01M16 14h.01M8 10h.01M8 14h.01"}]],
  "banco":[["path",{"d":"M3 22h18M6 18v-7M10 18v-7M14 18v-7M18 18v-7"}],["path",{"d":"m12 2 8 5H4z"}]],
  "peca":[["path",{"d":"M19.44 7.75a1.2 1.2 0 0 1-.86-2.06 2.5 2.5 0 1 0-3.54-3.54 1.2 1.2 0 0 1-2.06-.86V1H8a2 2 0 0 0-2 2v3.27a1.2 1.2 0 0 1-2.06.86A2.5 2.5 0 1 0 3.94 12a1.2 1.2 0 0 1 2.06.86V16a2 2 0 0 0 2 2h3.27a1.2 1.2 0 0 0 .86-2.06 2.5 2.5 0 1 1 3.54 0 1.2 1.2 0 0 0 .86 2.06H20a2 2 0 0 0 2-2v-3.27a1.2 1.2 0 0 0-2.06-.86 2.5 2.5 0 1 1 0-3.54 1.2 1.2 0 0 0 2.06-.86V8"}]],
  "robo":[["rect",{"x":"4","y":"8","width":"16","height":"12","rx":"2"}],["path",{"d":"M12 8V4M8 4h8"}],["path",{"d":"M2 14h2M20 14h2M9 13v2M15 13v2"}]],
  "arquivo":[["path",{"d":"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"}],["path",{"d":"M14 2v4a2 2 0 0 0 2 2h4"}],["path",{"d":"M10 9H8M16 13H8M16 17H8"}]],
  "arquivos":[["path",{"d":"M20 7h-3a2 2 0 0 1-2-2V2"}],["path",{"d":"M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z"}],["path",{"d":"M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8"}]],
  "pasta":[["path",{"d":"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"}]],
  "prancheta":[["rect",{"x":"8","y":"2","width":"8","height":"4","rx":"1"}],["path",{"d":"M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"}],["path",{"d":"M12 11h4M12 16h4M8 11h.01M8 16h.01"}]],
  "recibo":[["path",{"d":"M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"}],["path",{"d":"M8 8h8M8 12h8M8 16h5"}]],
  "editar":[["path",{"d":"M12 20h9"}],["path",{"d":"M16.38 3.62a1 1 0 0 1 3 3L7.37 18.64a2 2 0 0 1-.85.5l-2.87.84.84-2.87a2 2 0 0 1 .5-.85Z"}]],
  "lixo":[["path",{"d":"M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"}],["path",{"d":"M10 11v6M14 11v6"}]],
  "baixar":[["path",{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],["path",{"d":"m7 10 5 5 5-5M12 15V3"}]],
  "enviararquivo":[["path",{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],["path",{"d":"m17 8-5-5-5 5M12 3v12"}]],
  "caixa":[["path",{"d":"M22 12h-6l-2 3h-4l-2-3H2"}],["path",{"d":"M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"}]],
  "pacote":[["path",{"d":"M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"}],["path",{"d":"M12 22V12M3.3 7l8.7 5 8.7-5"}]],
  "salvar":[["path",{"d":"M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"}],["path",{"d":"M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7M7 3v4a1 1 0 0 0 1 1h7"}]],
  "imagem":[["rect",{"x":"3","y":"3","width":"18","height":"18","rx":"2"}],["circle",{"cx":"9","cy":"9","r":"2"}],["path",{"d":"m21 15-3.09-3.09a2 2 0 0 0-2.82 0L6 21"}]],
  "busca":[["circle",{"cx":"11","cy":"11","r":"8"}],["path",{"d":"m21 21-4.3-4.3"}]],
  "atualizar":[["path",{"d":"M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"}],["path",{"d":"M21 3v5h-5"}],["path",{"d":"M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"}],["path",{"d":"M8 16H3v5"}]],
  "repetir":[["path",{"d":"m17 2 4 4-4 4"}],["path",{"d":"M3 11v-1a4 4 0 0 1 4-4h14"}],["path",{"d":"m7 22-4-4 4-4"}],["path",{"d":"M21 13v1a4 4 0 0 1-4 4H3"}]],
  "ok":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"m9 12 2 2 4-4"}]],
  "erro":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"m15 9-6 6M9 9l6 6"}]],
  "alerta":[["path",{"d":"m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"}],["path",{"d":"M12 9v4M12 17h.01"}]],
  "info":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"M12 16v-4M12 8h.01"}]],
  "ampulheta":[["path",{"d":"M5 22h14M5 2h14"}],["path",{"d":"M17 22v-4.17a2 2 0 0 0-.59-1.42L12 12l-4.41 4.41A2 2 0 0 0 7 17.83V22"}],["path",{"d":"M7 2v4.17a2 2 0 0 0 .59 1.42L12 12l4.41-4.41A2 2 0 0 0 17 6.17V2"}]],
  "relogio":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"M12 6v6l4 2"}]],
  "bloqueado":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"m4.9 4.9 14.2 14.2"}]],
  "cadeado":[["rect",{"x":"3","y":"11","width":"18","height":"11","rx":"2"}],["path",{"d":"M7 11V7a5 5 0 0 1 10 0v4"}]],
  "chave":[["circle",{"cx":"7.5","cy":"15.5","r":"5.5"}],["path",{"d":"m21 2-9.6 9.6M15.5 7.5l3 3L22 7l-3-3"}]],
  "engrenagem":[["path",{"d":"M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"}],["circle",{"cx":"12","cy":"12","r":"3"}]],
  "ferramenta":[["path",{"d":"M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"}]],
  "raio":[["path",{"d":"M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"}]],
  "foguete":[["path",{"d":"M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"}],["path",{"d":"m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"}],["path",{"d":"M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"}]],
  "link":[["path",{"d":"M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"}],["path",{"d":"M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"}]],
  "externo":[["path",{"d":"M15 3h6v6M10 14 21 3"}],["path",{"d":"M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"}]],
  "calendario":[["rect",{"x":"3","y":"4","width":"18","height":"18","rx":"2"}],["path",{"d":"M16 2v4M8 2v4M3 10h18"}]],
  "grafico":[["path",{"d":"M3 3v18h18"}],["path",{"d":"M18 17V9M13 17V5M8 17v-3"}]],
  "calculadora":[["rect",{"x":"4","y":"2","width":"16","height":"20","rx":"2"}],["path",{"d":"M8 6h8M16 14v4M16 10h.01M12 10h.01M8 10h.01M12 14h.01M8 14h.01M12 18h.01M8 18h.01"}]],
  "dinheiro":[["circle",{"cx":"8","cy":"8","r":"6"}],["path",{"d":"M18.09 10.37A6 6 0 1 1 10.34 18M7 6h1v4M16.71 13.88l.7.71-2.82 2.82"}]],
  "cartao":[["rect",{"x":"2","y":"5","width":"20","height":"14","rx":"2"}],["path",{"d":"M2 10h20"}]],
  "celular":[["rect",{"x":"5","y":"2","width":"14","height":"20","rx":"2"}],["path",{"d":"M12 18h.01"}]],
  "monitor":[["rect",{"x":"2","y":"3","width":"20","height":"14","rx":"2"}],["path",{"d":"M8 21h8M12 17v4"}]],
  "nuvem":[["path",{"d":"M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"}]],
  "sinal":[["path",{"d":"M4.9 19.1C1 15.2 1 8.8 4.9 4.9M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5"}],["circle",{"cx":"12","cy":"12","r":"2"}],["path",{"d":"M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5M19.1 4.9C23 8.8 23 15.1 19.1 19"}]],
  "tv":[["rect",{"x":"2","y":"7","width":"20","height":"15","rx":"2"}],["path",{"d":"m17 2-5 5-5-5"}]],
  "filtro":[["path",{"d":"M22 3H2l8 9.46V19l4 2v-8.54L22 3z"}]],
  "mais":[["path",{"d":"M12 5v14M5 12h14"}]],
  "fechar":[["path",{"d":"M18 6 6 18M6 6l12 12"}]],
  "check":[["path",{"d":"M20 6 9 17l-5-5"}]],
  "voltar":[["path",{"d":"m15 18-6-6 6-6"}]],
  "avancar":[["path",{"d":"m9 18 6-6-6-6"}]],
  "baixo":[["path",{"d":"m6 9 6 6 6-6"}]],
  "cima":[["path",{"d":"m18 15-6-6-6 6"}]],
  "mais3":[["circle",{"cx":"12","cy":"12","r":"1"}],["circle",{"cx":"19","cy":"12","r":"1"}],["circle",{"cx":"5","cy":"12","r":"1"}]],
  "olho":[["path",{"d":"M2.06 12.35a1 1 0 0 1 0-.7 10.75 10.75 0 0 1 19.88 0 1 1 0 0 1 0 .7 10.75 10.75 0 0 1-19.88 0"}],["circle",{"cx":"12","cy":"12","r":"3"}]],
  "estrela":[["path",{"d":"M11.53 2.3a.53.53 0 0 1 .94 0l2.31 4.68a2.12 2.12 0 0 0 1.6 1.16l5.16.76a.53.53 0 0 1 .3.9l-3.74 3.64a2.12 2.12 0 0 0-.61 1.88l.88 5.14a.53.53 0 0 1-.77.56l-4.62-2.43a2.12 2.12 0 0 0-1.97 0L6.4 21.02a.53.53 0 0 1-.77-.56l.88-5.14a2.12 2.12 0 0 0-.61-1.88L2.16 9.8a.53.53 0 0 1 .3-.9l5.16-.76a2.12 2.12 0 0 0 1.6-1.16z"}]],
  "lampada":[["path",{"d":"M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"}],["path",{"d":"M9 18h6M10 22h4"}]],
  "casa":[["path",{"d":"m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"}],["path",{"d":"M9 22V12h6v10"}]],
  "escudo":[["path",{"d":"M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"}]],
  "balanca":[["path",{"d":"m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1ZM2 16l3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"}],["path",{"d":"M7 21h10M12 3v18M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"}]],
  "livro":[["path",{"d":"M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"}]],
  "maleta":[["rect",{"x":"2","y":"7","width":"20","height":"14","rx":"2"}],["path",{"d":"M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"}]],
  "folha":[["path",{"d":"M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"}],["path",{"d":"M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"}]],
  "globo":[["circle",{"cx":"12","cy":"12","r":"10"}],["path",{"d":"M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20M2 12h20"}]],
  "email":[["rect",{"x":"2","y":"4","width":"20","height":"16","rx":"2"}],["path",{"d":"m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"}]],
  "contato":[["rect",{"x":"3","y":"4","width":"18","height":"18","rx":"2"}],["circle",{"cx":"12","cy":"10","r":"3"}],["path",{"d":"M7 22v-1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1M8 2v2M16 2v2"}]],
  "marcador":[["path",{"d":"M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.42l8.7 8.7a2.43 2.43 0 0 0 3.42 0l6.58-6.58a2.43 2.43 0 0 0 0-3.42z"}],["circle",{"cx":"7.5","cy":"7.5","r":".5"}]],
  "play":[["path",{"d":"m6 3 14 9-14 9V3z"}]],
  "pausa":[["rect",{"x":"6","y":"4","width":"4","height":"16","rx":"1"}],["rect",{"x":"14","y":"4","width":"4","height":"16","rx":"1"}]],
  "zoom":[["circle",{"cx":"11","cy":"11","r":"8"}],["path",{"d":"m21 21-4.3-4.3M11 8v6M8 11h6"}]],
  "pin":[["path",{"d":"M20 10c0 4.99-5.54 10.19-7.4 11.8a1 1 0 0 1-1.2 0C9.54 20.19 4 14.99 4 10a8 8 0 0 1 16 0"}],["circle",{"cx":"12","cy":"10","r":"3"}]],
  "impressora":[["path",{"d":"M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"}],["path",{"d":"M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"}],["rect",{"x":"6","y":"14","width":"12","height":"8","rx":"1"}]],
  "troca":[["path",{"d":"m16 3 4 4-4 4M20 7H4M8 21l-4-4 4-4M4 17h16"}]],
  "diploma":[["path",{"d":"M22 10v6M2 10l10-5 10 5-10 5z"}],["path",{"d":"M6 12v5c3 3 9 3 12 0v-5"}]],
  "arvore":[["path",{"d":"M12 22v-7l-2-2"}],["path",{"d":"M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z"}],["path",{"d":"m14 14-2 2"}]]};

/* Estilo do ícone na frente de texto. Injetado uma vez no <head> (sem import de
   .css, pelo mesmo motivo de cima). */
const CSS = `svg.icone.icone-txt{width:1.05em;height:1.05em;margin-right:.3em;vertical-align:-.16em}
h1>svg.icone.icone-txt,h2>svg.icone.icone-txt,.page-title>svg.icone.icone-txt{width:.9em;height:.9em;opacity:.85}`;
function injetarCss() {
  if (typeof document === 'undefined' || document.getElementById('icone-css')) return;
  const st = document.createElement('style');
  st.id = 'icone-css'; st.textContent = CSS;
  document.head.appendChild(st);
}

export default function Icone({ nome, tamanho = 16, className = '', style, titulo, espessura = 1.8 }) {
  injetarCss();
  const partes = D[nome] || [['circle', { cx: '12', cy: '12', r: '8' }]];
  return h('svg', {
    className: `icone${className ? ` ${className}` : ''}`,
    width: tamanho, height: tamanho, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
    strokeWidth: espessura, strokeLinecap: 'round', strokeLinejoin: 'round',
    style: { flex: 'none', verticalAlign: '-0.18em', ...style },
    'aria-hidden': titulo ? undefined : true, role: titulo ? 'img' : undefined, 'aria-label': titulo,
  }, partes.map(([tag, a], i) => h(tag, { key: i, ...a })));
}

export const NOMES_ICONE = Object.keys(D);

/* Emoji que existia no cockpit → ícone equivalente. Usado onde o emoji vem de
   dado (lista de atalhos, rótulo que muda com o estado), não do JSX direto. */
const DE_EMOJI = {
  '⛔': 'bloqueado',
  '♻': 'repetir',
  '⏭': 'avancar',
  '✨': 'estrela',
  '🌅': 'casa',
  '📒': 'livro',
  '🚨': 'alerta',
  '🎨': 'editar',
  '🚦': 'sinal',
  '🩺': 'escudo',
  '🪞': 'olho',
  '🏆': 'estrela',
  '🩹': 'ferramenta',
  '❓': 'info',
  '🖊': 'editar',
  '🖋': 'editar',
  '🔏': 'cadeado',
  '🪪': 'contato',
  '🧬': 'peca',
  '🔇': 'microfone-off',
  '⏱': 'relogio',
  '🎬': 'video',
  '🐛': 'alerta',
  '📄': 'arquivo',
  '📃': 'arquivo',
  '📑': 'arquivos',
  '🗂': 'arquivos',
  '📁': 'pasta',
  '📂': 'pasta',
  '🗃': 'arquivos',
  '🔄': 'atualizar',
  '🔃': 'atualizar',
  '🔁': 'repetir',
  '📋': 'prancheta',
  '🧾': 'recibo',
  '📊': 'grafico',
  '📈': 'grafico',
  '📉': 'grafico',
  '🔎': 'busca',
  '🔍': 'busca',
  '🤖': 'robo',
  '📎': 'clipe',
  '💰': 'dinheiro',
  '💵': 'dinheiro',
  '💸': 'dinheiro',
  '⚡': 'raio',
  '📥': 'baixar',
  '📤': 'enviararquivo',
  '🔒': 'cadeado',
  '🔐': 'cadeado',
  '🔓': 'cadeado',
  '🚫': 'bloqueado',
  '⚙': 'engrenagem',
  '🧮': 'calculadora',
  '📝': 'editar',
  '✏': 'editar',
  '✍': 'editar',
  '📡': 'sinal',
  '🏢': 'predio',
  '🏛': 'banco',
  '🏦': 'banco',
  '💾': 'salvar',
  '🖥': 'monitor',
  '💻': 'monitor',
  '🔗': 'link',
  '🚀': 'foguete',
  '📅': 'calendario',
  '📆': 'calendario',
  '🗓': 'calendario',
  '🔑': 'chave',
  '📦': 'pacote',
  '👥': 'usuarios',
  '👤': 'usuario',
  '🎤': 'microfone',
  '💬': 'mensagem',
  '🗨': 'mensagem',
  '☁': 'nuvem',
  '🚜': 'foguete',
  '📱': 'celular',
  '📲': 'celular',
  '📇': 'contato',
  '🛠': 'ferramenta',
  '🔧': 'ferramenta',
  '📞': 'telefone',
  '☎': 'telefone',
  '📜': 'arquivo',
  '💳': 'cartao',
  '✅': 'ok',
  '❌': 'erro',
  '⏳': 'ampulheta',
  '⌛': 'ampulheta',
  '⏰': 'relogio',
  '🕐': 'relogio',
  '🔔': 'sino',
  '🔕': 'sino-off',
  '📺': 'tv',
  '🗑': 'lixo',
  '📌': 'fixar',
  '📍': 'pin',
  '🎥': 'video',
  '📹': 'video',
  '📷': 'imagem',
  '🖼': 'imagem',
  '⚠': 'alerta',
  'ℹ': 'info',
  '💡': 'lampada',
  '⭐': 'estrela',
  '🌟': 'estrela',
  '🏠': 'casa',
  '🛡': 'escudo',
  '⚖': 'balanca',
  '📚': 'livro',
  '📖': 'livro',
  '📘': 'livro',
  '💼': 'maleta',
  '🌐': 'globo',
  '📧': 'email',
  '✉': 'email',
  '📨': 'email',
  '📬': 'caixa',
  '📭': 'caixa',
  '📮': 'caixa',
  '🏷': 'marcador',
  '▶': 'play',
  '⏸': 'pausa',
  '🖨': 'impressora',
  '🔀': 'troca',
  '↔': 'troca',
  '🎓': 'diploma',
  '🧩': 'peca',
  '👁': 'olho',
  '👀': 'olho',
  '🎯': 'alerta',
  '🧪': 'ferramenta',
  '🆕': 'mais',
  '➕': 'mais',
  '🔙': 'voltar',
  '🧭': 'globo',
  '🗺': 'globo',
  '🌱': 'folha',
  '🍃': 'folha',
  '🧠': 'lampada',
  '🔬': 'busca',
  '📣': 'sinal',
  '📢': 'sinal',
  '🧑‍💼': 'usuario',
  '👨‍💼': 'usuario',
  '👩‍💼': 'usuario',
};
const SELETORES = /[\uFE0E\uFE0F]/g;

/** Nome do ícone de um emoji, ou null quando não há equivalente. */
export function iconeDoEmoji(emoji) {
  if (typeof emoji !== 'string') return null;
  return DE_EMOJI[emoji.replace(SELETORES, '').trim()] || null;
}

/** Desenha o ícone de um emoji; sem equivalente, mostra o próprio emoji. */
export function IconeDeEmoji({ e, tamanho = 16, ...resto }) {
  const nome = iconeDoEmoji(e);
  return nome ? h(Icone, { nome, tamanho, ...resto }) : (e ?? null);
}

/**
 * Rótulo que começa com emoji ("⏳ Gerando…") vira ícone + texto. Qualquer
 * outra coisa (número, elemento, texto sem emoji) volta como veio.
 */
export function comIcone(rotulo) {
  if (typeof rotulo !== 'string') return rotulo;
  const m = rotulo.match(/^(\S+?)[\uFE0E\uFE0F]?\s+([\s\S]*)$/u);
  if (!m) { const so = iconeDoEmoji(rotulo); return so ? h(Icone, { nome: so }) : rotulo; }
  const nome = iconeDoEmoji(m[1]);
  if (!nome) return rotulo;
  return h(React.Fragment, null, h(Icone, { nome, className: 'icone-txt' }), ` ${m[2]}`);
}
